import React from 'react';
import { Edit2, Trash2, Tag, Search, Plus } from 'lucide-react';

const StatutTable = ({ 
  statuts, 
  loading, 
  onEdit, 
  onDelete,
  onAdd,
  searchTerm 
}) => {
  if (loading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#202654]"></div>
      </div>
    );
  }

  return (
    <div className="bg-white shadow-sm rounded-lg overflow-hidden">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Libellé
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Date de création
            </th>
            <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {statuts.length === 0 ? (
            <tr>
              <td colSpan="3" className="px-6 py-12 text-center text-sm text-gray-500">
                {searchTerm ? (
                  <div className="flex flex-col items-center">
                    <Search className="h-8 w-8 text-gray-300 mb-2" />
                    <p>Aucun statut ne correspond à votre recherche.</p>
                  </div>
                ) : (
                  <div className="flex flex-col items-center">
                    <Tag className="h-8 w-8 text-gray-300 mb-2" />
                    <p>Aucun statut d'enseignant n'a été créé.</p>
                    <button
                      onClick={onAdd}
                      className="mt-2 inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
                    >
                      <Plus className="h-4 w-4 mr-1" /> Ajouter un statut
                    </button>
                  </div>
                )}
              </td>
            </tr>
          ) : (
            statuts.map((statut) => (
              <tr key={statut.id} className="hover:bg-gray-50 transition-colors">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="h-9 w-9 rounded-full bg-purple-100 flex items-center justify-center mr-3">
                      <Tag className="h-5 w-5 text-purple-600" />
                    </div>
                    <div className="text-sm font-medium text-gray-900">
                      {statut.libelle}
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {new Date(statut.create_at).toLocaleDateString('fr-FR')}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <button
                    onClick={() => onEdit(statut)}
                    className="text-indigo-600 hover:text-indigo-900 mr-4 p-1 rounded-full hover:bg-indigo-50 transition-colors"
                    title="Modifier"
                  >
                    <Edit2 className="h-5 w-5" />
                  </button>
                  <button
                    onClick={() => onDelete(statut)}
                    className="text-red-600 hover:text-red-900 p-1 rounded-full hover:bg-red-50 transition-colors"
                    title="Supprimer"
                  >
                    <Trash2 className="h-5 w-5" />
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default StatutTable; 